import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderCloseAtom = createMutationAtomFactory(
  'trade.purchaseOrderClose',
  (params: { id: string; notes?: string | null }) => ({
    tradePurchaseOrderClose: {
      __args: {
        id: params.id,
        notes: params.notes,
      },
      id: true,
      status: true,
      documentNumber: true,
      completionNotes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
